module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAACXBIWXMAAAsSAAALEgHS3X78AAAAQUlEQVQ4jWP8//8/A7XA1CkTDoCMYqGaiRBgDyKZqGwow6iho4aOGjpq6Kih1AMssCqAqobCqgBqG+pIVRMZGBgAKUEI4u2urL0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/resize.png
// module id = 598
// module chunks = 2